import { addDoc, collection } from "firebase/firestore";
import * as XLSX from "xlsx";
import { db } from "../../firebase";

// 숫자 정규화 (1,000,000 / "1000000" / 숫자 모두 대응)
const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  const n = Number(String(value).replace(/,/g, "").trim());
  return Number.isNaN(n) ? 0 : n;
};

const mapRowToItem = (row) => {
  const rawType = String(row["구분"] ?? "").trim();
  const itemType = rawType === "기타 기자재" || rawType === "유산소 기구" ? rawType : "웨이트 기구";

  return {
    itemType,
    name: String(row["제품명"] ?? "").trim() || "-",
    model: String(row["모델"] ?? "").trim() || "-",
    series: String(row["시리즈"] ?? "").trim() || "-",
    format: String(row["양식"] ?? "").trim() || "-",
    description: String(row["설명"] ?? "").trim() || "-",
    price: toNumber(row["가격"]),
    image: "",
    createdAt: new Date().toISOString(),
  };
};

// 필수값 검증
const validateRow = (row, rowIndex) => {
  const name = String(row["제품명"] ?? "").trim();
  const model = String(row["모델"] ?? "").trim();
  if (!name || !model) {
    return `(${rowIndex + 2}행) 제품명/모델은 필수입니다.`; // +2: 헤더 포함
  }
  return null;
};

// 엑셀 파일 업로드 실행 함수
export const runExcelUpload = async (file) => {
  if (!file) return { ok: false, message: "파일이 없습니다." };
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  if (!workbook.SheetNames.length) {
    return { ok: false, message: "시트가 없습니다." };
  }
  const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });
  if (!rows.length) {
    return { ok: false, message: "업로드할 데이터가 없습니다." };
  }
  for (let i = 0; i < rows.length; i++) {
    const err = validateRow(rows[i], i);
    if (err) return { ok: false, message: err };
  }

  try {
    // 저장
    const itemsRef = collection(db, "deploy", "estimate", "items");
    let successCount = 0;
    for (const row of rows) {
      await addDoc(itemsRef, mapRowToItem(row));
      successCount += 1;
    }
    return {
      ok: true,
      message: `업로드 완료: ${successCount}건`,
      data: { total: rows.length, success: successCount, fail: rows.length - successCount },
    };
  } catch (e) {
    return { ok: false, message: "엑셀 업로드 실패" };
  }
};
